// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5536":"fe32267ec2de1346","7685":"811177871c7cbae6","9730":"0dffb57325612553"}[chunkId] + ".css";
};